import { Box, Typography } from '@mui/material';
import { LogoMark } from '../layout/BrandMark';
import { alpha, tokens } from '../../theme/tokens';

export function LoadingState({ label = 'Loading…' }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        py: { xs: 2.5, sm: 3.5, md: 4.5 },
        px: { xs: 1.75, sm: 2 },
        borderRadius: { xs: 2, sm: 2.5 },
        bgcolor: tokens.surface,
        color: tokens.ink,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: `0 12px 28px ${alpha(tokens.shellDeep, 0.18)}`,
      }}
    >
      <LogoMark size={40} animated />
      <Typography sx={{ color: tokens.inkMuted, minWidth: 0 }} fontWeight={500}>
        {label}
      </Typography>
    </Box>
  );
}
